import { useEffect, useCallback, useState } from "react";

import { PageLoader } from "@/components";

import { useCustomerPortal } from "./hooks/useCustomerPortal";

// This screen will be opened in a new tab
// It just displays a loading page while the portal URL is being fetched
// and then redirect to the portal URL in the same window (to avoid popup blocker issues)
export const ManageSubscriptionScreen = () => {
  const customerPortal = useCustomerPortal();
  const [isLoading, setIsLoading] = useState(false);

  const redirectToPortal = useCallback(() => {
    customerPortal.mutate(undefined, {
      onSuccess: ({ url }) => {
        window.location.href = url;
      },
    });
  }, [customerPortal]);

  useEffect(() => {
    if (!isLoading) {
      redirectToPortal();
      setIsLoading(true);
    }
  }, [redirectToPortal, isLoading]);

  return <PageLoader />;
};
